import TablePagination from "@mui/material/TablePagination";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import "../../pages/Maps&Actions/styles.scss";

function Pagination({
  currentPage,
  handlePagination,
  currentLimit,
  limits,
  totalItems,
}) {
  const totalPages = Math.ceil(totalItems / currentLimit);
  const isFirstPage = currentPage <= 0;
  const isLastPage = currentPage >= totalPages;

  const PaginationActions = (props) => {
    const { page, onPageChange } = props;

    return (
      <>
        {isFirstPage ? (
          <span style={{ cursor: "not-allowed" }}>
            <IconButton disabled sx={{ cursor: "not-allowed" }}>
              <KeyboardArrowLeft style={{ fontSize: "23pt" }} />
            </IconButton>
          </span>
        ) : (
          <Tooltip title="Página anterior" arrow>
            <span>
              <IconButton
                onClick={(e) => onPageChange(e, page - 1)}
                sx={{ cursor: "pointer" }}
              >
                <KeyboardArrowLeft style={{ fontSize: "25pt" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {isLastPage ? (
          <span style={{ cursor: "not-allowed" }}>
            <IconButton disabled sx={{ cursor: "not-allowed" }}>
              <KeyboardArrowRight style={{ fontSize: "25pt" }} />
            </IconButton>
          </span>
        ) : (
          <Tooltip title="Próxima página" arrow>
            <span>
              <IconButton
                onClick={(e) => onPageChange(e, page + 1)}
                sx={{ cursor: "pointer" }}
              >
                <KeyboardArrowRight style={{ fontSize: "25pt" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </>
    );
  };

return (
  <TablePagination
    component="div"
    count={totalItems}
    page={currentPage - 1}
    onPageChange={(e, newPage) =>
      handlePagination(newPage + 1)
    }
    rowsPerPage={currentLimit}
    onRowsPerPageChange={limits}
    rowsPerPageOptions={[
      20,
      30,
      50,
      100,
      totalItems,
    ]}
    labelRowsPerPage="Veículos por página:"

    sx={{
  

    


      minHeight: "60px",

      "& .MuiTablePagination-selectLabel": {
        color: "#fff",
      },

      "& .MuiTablePagination-displayedRows": {
        color: "#fff",
      },

      "& .MuiTablePagination-select": {
        color: "#fff",
      },

      "& .MuiSvgIcon-root": {
        color: "#fff",
      },

      "& .MuiIconButton-root": {
        color: "#fff",
      },

      "& .MuiTablePagination-toolbar": {
        minHeight: "60px",
      },
    }}

    SelectProps={{
      MenuProps: {
        disableScrollLock: true,
        PaperProps: {
          sx: {
            boxShadow:
              "0 8px 24px rgba(0,0,0,0.18)",
          },
        },
      },
    }}

    ActionsComponent={PaginationActions}

    labelDisplayedRows={() => {
      if (!totalItems)
        return "Carregando veículos...";

      const pageSafe =
        Math.max(currentPage + 1);

      return `Total de veículos ${totalItems} | Página ${pageSafe} de ${totalPages}`;
    }}
  />
);
}

export default Pagination;
